import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import formatter from '../../common/helpers/formatter';
import type { Documentation } from '../../common/types/documentation';

type Props = {
  item: Documentation;
};

function DateHoursDepartmentRow({ item }: Props) {
  return (
    <Stack flex={1} direction='row' spacing={2} justifyContent='flex-start'>
      <Typography>{formatter.formatGermanDate(item.date)}</Typography>
      <Stack direction='column' spacing={1} justifyContent='center'>
        <Typography fontWeight='bold'>{item.department}</Typography>
        <Typography
          fontSize='0.8rem'
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Stunden: {item.hours}
        </Typography>
      </Stack>
    </Stack>
  );
}

export default DateHoursDepartmentRow;
